module.exports = __webpack_public_path__ + "87f94252.jpg";